<template>
  <div class="flow-plan-container">
    <div class="searchDiv">
      <!--      <el-input class="searchInput" v-model="params.name" placeholder="请输入流程名称" clearable @clear="getPageList"-->
      <!--                @keyup.enter.native="getPageList"/>-->
      <!--      <el-button type="primary" @click="getPageList">查询</el-button>-->
      <el-button v-if="hasPer('flow:design')" @click="editRow" style="float: right;">新增</el-button>
    </div>
    <el-table class="tablebox" :data="tableData" row-key="id" border height="100%">
      <el-table-column label="方案名称" prop="name" width="250px"></el-table-column>
      <el-table-column label="编码" prop="code"></el-table-column>
      <el-table-column label="启停状态" prop="status">
        <template slot-scope="scope">
          <p>{{ $dict.nameOf('start_stop', String(scope.row.status)) }}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="option" width="220px" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('flow:design')" type="primary"
                     @click="editRow(JSON.parse(JSON.stringify(scope.row)))">
            编辑
          </el-button>
          <el-button v-if="hasPer('flow:design')" type="danger" @click="delRow(scope.row.id, scope.row.name)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <edit-flow-plan :dialog-visible.sync="dialogVisible" :data-obj="rowDataObj" :flow-id="flowId"
                    @get-list="getPageList"></edit-flow-plan>
  </div>
</template>

<script>
import {delFlowPlan, getFlowPlanList} from "@/api/sys/flow/flow";
import {infoMsg, successMsg} from "@/utils/message";
import {hasPer} from "@/utils/common";
import store from "@/store";
import EditFlowPlan from "@/views/approval/flow/editFlowPlan.vue";

export default {
  name: "flowPlan",
  components: {
    EditFlowPlan
  },
  props: {
    flowId: {
      type: [String, Number],
      require: true,
      default: ''
    }
  },
  data() {
    return {
      params: {},
      username: store.state.userInfo.username,
      tableData: [],
      dialogVisible: false,
      rowDataObj: {},
      current: 1,
      size: 10,
      total: 0
    }
  },
  mounted() {
    this.getPageList();
  },
  methods: {
    hasPer,
    getPageList() {
      getFlowPlanList({flowId: this.flowId}).then(res => {
        this.tableData = res
      })
    },
    editRow(row) {
      this.rowDataObj = row.id ? row : {flowId: this.flowId}
      this.dialogVisible = true
    },
    delRow(id, name) {
      this.$confirm('确定删除执行方案【' + name + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delFlowPlan(id).then(() => {
          successMsg('操作成功')
          this.getPageList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    buttonType(type) {
      if (type) {
        return 'warning'
      } else {
        return 'success'
      }
    }
  }
}
</script>

<style scoped>
.flow-plan-container {
  .tablebox {
    max-height: calc(100vh - 350px);
    min-height: 250px;
    overflow-y: auto;
  }
}
</style>
